const BOTTOM_HEIGHT = 80;
export const productTileBottomHeight = [`${BOTTOM_HEIGHT}px`];
